import { QueryClient } from "/npm/@tanstack/solid-query@^5.67.1/+esm";
import { persistQueryClient } from "/npm/@tanstack/solid-query-persist-client@^5.67.1/+esm";
import { createSyncStoragePersister } from "/npm/@tanstack/query-sync-storage-persister@^5.67.1/+esm";
import lz from "/npm/lz-string@^1.5.0/+esm";

const client = new QueryClient();

persistQueryClient({
  queryClient: client,
  persister: createSyncStoragePersister({
    storage: window.localStorage,
    serialize: (data) => lz.compressToUTF16(JSON.stringify(data)),
    deserialize: (data) => JSON.parse(lz.decompressFromUTF16(data)),
    key: "brytdesigns-hybrid-cart",
  }),
});

export default client;
